import * as React from "react";

import type { IIconBaseProps } from "@/components/icons";
import { IconWrapper } from "@/components/icons/iconWrapper";

export function Tick(allProps: IIconBaseProps) {
  const { svgProps: props, iconStyle, ...restProps } = allProps;
  const styles: Record<string, React.ReactNode> = {
    Broken: (
      <svg
        width={"16"}
        height={"12"}
        viewBox={"0 0 16 12"}
        fill={"none"}
        xmlns={"http://www.w3.org/2000/svg"}
      >
        <path
          d={"M1.7793 5.99969L7.11073 10.4447L14.2193 1.55469"}
          stroke={"white"}
          strokeWidth={"2"}
          strokeLinecap={"round"}
        />
      </svg>
    ),
    LineDuotone: (
      <svg
        width={"16"}
        height={"12"}
        viewBox={"0 0 16 12"}
        fill={"none"}
        xmlns={"http://www.w3.org/2000/svg"}
      >
        <path
          d={"M1.7793 5.99969L7.11073 10.4447L14.2193 1.55469"}
          stroke={"white"}
          strokeWidth={"2"}
          strokeLinecap={"round"}
        />
      </svg>
    ),
    Linear: (
      <svg
        width={"16"}
        height={"12"}
        viewBox={"0 0 16 12"}
        fill={"none"}
        xmlns={"http://www.w3.org/2000/svg"}
      >
        <path
          d={"M1.7793 5.99969L7.11073 10.4447L14.2193 1.55469"}
          stroke={"white"}
          strokeWidth={"2"}
          strokeLinecap={"round"}
        />
      </svg>
    ),
    Outline: (
      <svg
        width={"16"}
        height={"12"}
        viewBox={"0 0 16 12"}
        fill={"none"}
        xmlns={"http://www.w3.org/2000/svg"}
      >
        <path
          d={"M1.7793 5.99969L7.11073 10.4447L14.2193 1.55469"}
          stroke={"white"}
          strokeWidth={"2"}
          strokeLinecap={"round"}
        />
      </svg>
    ),
    Bold: (
      <svg
        width={"16"}
        height={"12"}
        viewBox={"0 0 16 12"}
        fill={"none"}
        xmlns={"http://www.w3.org/2000/svg"}
      >
        <path
          d={"M1.7793 5.99969L7.11073 10.4447L14.2193 1.55469"}
          stroke={"white"}
          strokeWidth={"2"}
          strokeLinecap={"round"}
        />
      </svg>
    ),
    BoldDuotone: (
      <svg
        width={"16"}
        height={"12"}
        viewBox={"0 0 16 12"}
        fill={"none"}
        xmlns={"http://www.w3.org/2000/svg"}
      >
        <path
          d={"M1.7793 5.99969L7.11073 10.4447L14.2193 1.55469"}
          stroke={"white"}
          strokeWidth={"2"}
          strokeLinecap={"round"}
        />
      </svg>
    ),
  };

  return <IconWrapper icon={styles[iconStyle || "Linear"]} {...restProps} />;
}
